import * as React from "react";
import { cn } from "../../lib/utils";

export interface HintProps extends React.HTMLAttributes<HTMLDivElement> {}

/**
 * Markiert einen Hinweistext. Über die Einstellung "Hinweise anzeigen" werden
 * alle `Hint`-Elemente ausgeblendet (siehe `styles/globals.css`, Klasse
 * `p2p-hint`).
 */
export const Hint = React.forwardRef<HTMLDivElement, HintProps>(
  ({ className, ...props }, ref) => (
    <div ref={ref} className={cn("p2p-hint", className)} {...props} />
  ),
);
Hint.displayName = "Hint";
